module.exports = __webpack_public_path__ + "static/media/pivi.97c645bf.png";